import { GCB_Container, grandChartBodyVariants } from "./GrandChartBody.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../../../stores";
import { Courses } from "./Courses";
import { GroupsLesson } from "./GroupLessonArea/GroupsLesson";
import { GroupLessonArea } from "./GroupLessonArea";

interface GrandChartBodyProps {}

export const GrandChartBody = observer(({}: GrandChartBodyProps) => {
	const { grandCharts } = useStores();
	const { selected } = grandCharts;

	const isGroupLessonView = Boolean(selected.selectedGrandChartGroupLesson.id);

	return (
		<GCB_Container
			$modulesCount={selected.grand_chart_modules.length}
			$isGroupLessonView={isGroupLessonView}
			variants={grandChartBodyVariants}
		>
			<Courses />
			<GroupLessonArea />
		</GCB_Container>
	);
});
